import { HttpContext } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { I18nPipe, SettingsService, _HttpClient } from '@delon/theme';
import { AuthService } from '@share';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTabChangeEvent, NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    I18nPipe,
    NzCheckboxModule,
    NzTabsModule,
    NzAlertModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzToolTipModule,
    NzIconModule],

  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {

  private readonly messageService=inject(NzMessageService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService)
  //private readonly settingsService = inject(SettingsService);
  //private readonly socialService = inject(SocialService);
  //private readonly reuseTabService = inject(ReuseTabService, { optional: true });
  //private readonly tokenService = inject(DA_SERVICE_TOKEN);
  //private readonly startupSrv = inject(StartupService);
  private readonly http = inject(_HttpClient);
  //private readonly cdr = inject(ChangeDetectorRef);
  constructor(private ngZone: NgZone) {
    if (this.authService.isAuthenticated()) {
      this.ngZone.run(() => {
        this.navigateToLanding();
      });
    }
  }
  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.navigateToLanding();
    }
  }

  form = inject(FormBuilder).nonNullable.group({
    userName: ['', [Validators.required]],
    password: ['', [Validators.required]],
    // mobile: ['', [Validators.required, Validators.pattern(/^1\d{10}$/)]],
    // captcha: ['', [Validators.required]],
    //remember: [true]
  });

  error = '';
  type = 0;
  loading = false;

  count = 0;
  interval$: any;

  submit(): void {
    this.error = '';
    if (this.type === 0) {
      const { userName, password } = this.form.controls;
      userName.markAsDirty();
      userName.updateValueAndValidity();
      password.markAsDirty();
      password.updateValueAndValidity();
      if (userName.invalid || password.invalid) {
        return;
      }

    } else {
      // const { mobile, captcha } = this.form.controls;
      // mobile.markAsDirty();
      // mobile.updateValueAndValidity();
      // captcha.markAsDirty();
      // captcha.updateValueAndValidity();
      // if (mobile.invalid || captcha.invalid) {
      //   return;
      // }
    }

    this.loading = true;
    //this.cdr.detectChanges();

    this.authService.login({ email: this.form.controls['userName'].value, password: this.form.controls['password'].value })
      .subscribe({
        next: response => {
          this.loading = false;
          
        },
        error: error => {
          // Handle the error
          this.messageService.error(JSON.stringify(error.error));
          console.error('Login error:', error);
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
          this.ngZone.run(() => {
            this.navigateToLanding();
          });
          console.log('Login attempt complete');
        }
      });


  }

  switch({ index }: NzTabChangeEvent): void {
    this.type = index!;
  }

  async navigateToLanding() {
    const landingRoute = this.authService.getLandingRoute();
    const target = landingRoute ? [landingRoute] : ['/auth/forbidden'];
    try {
      await this.router.navigate(target);
      // Navigation succeeded
    } catch (error:any) {
      console.error('Navigation failed:', error);
      // Handle the error (redirect to fallback, show message, etc.)
      //this.router.navigate(['/fallback']);
      // Or display an error message
      this.messageService.error(error);
    }
  }
}
